import { createAction } from '@reduxjs/toolkit';

import type { IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';
import type { FacetValueBase } from 'Models/index';
import type { ServerModel } from 'Modules/serverApi/types';

export type VehicleActionMeta = {
  isAutoVehicleSelectionDisabled?: boolean;
  isPartialMode?: boolean;
  sendIsolatedRequest?: boolean;
  doNotRedirectOnVehicleSelect?: boolean;
  redirectUrl?: string;
  vehicleWidgetName?: string;
};

type SetResponseMeta = VehicleActionMeta & {
  appendItems?: boolean;
  isolatedKey?: IsolatedKey;
  isSelectedFromVehicleSpecs?: boolean;
  onInit?: true;
  preselection?: FacetValueBase[];
  withCurrentVehicle?: boolean;
};

export function defaultSetResponseMeta(
  meta: SetResponseMeta,
): SetResponseMeta & { isolatedKey: IsolatedKey | null; preselection: FacetValueBase[] } {
  return { isolatedKey: null, preselection: [], ...meta };
}

export const setResponse = createAction(
  'SET_RESPONSE',
  (payload: ServerModel.SearchResponse, meta: SetResponseMeta = {}) => ({
    payload,
    meta: defaultSetResponseMeta(meta),
  }),
);

export const setServerRedirect = createAction<string>('SET_SERVER_REDIRECT');

export const setResponseExtra = createAction<ServerModel.GenericItem>('SET_RESPONSE_EXTRA');
